export const externalContactLink =
  'https://meetings.grooveapp.com/abby-blumenfeld';
